<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header card-header-rose card-header-icon">
        <div class="card-icon">
          <i class="material-icons">assignment</i>
        </div>
        <h4 class="card-title">Modifier mes jobs alertes</h4>
      </div>
      <div class="card-body" id="wizardProfile">
        <div class="row">
          <div class="col-md-12">
            <i class="material-icons" style="color: #E30512;">insert_drive_file</i>&nbsp;&nbsp;<label>Insérer CV: </label>&nbsp;&nbsp;<input type="file" (change)="handleUpload($event)">
            <br />
            <i class="material-icons" style="color: #E30512;">insert_drive_file</i>&nbsp;&nbsp;<label>Insérer Lettre de motivation: </label>&nbsp;&nbsp;<input (change)="handleUploadCL($event)" type="file">
            <br />
          </div>
        </div>
        <div class="card-footer text-center">
          <button mat-button mat-raised-button mat-dialog-close class="btn btn-rose">Enregistrer</button>&nbsp;&nbsp;
        </div>
      </div>
    </div>
  </div>
</div>
